import React from 'react';

const Label = ({ background, children, marginRight = 0, marginLeft = 0 }) => {
    return (
      <div
        className="label"
        style={{ background: background, marginRight: marginRight, marginLeft: marginLeft }}
      >
        <span>{children}</span>
      </div>
    );
  };

  export default Label;


// WEBPACK FOOTER //
// ./src/components/theme/Label/Label.jsx